export default __webpack_public_path__ + "static/media/contactUs.d1afc52a.jpg";